module.exports = __webpack_public_path__ + "img/sleepIcon.bc47d87f.png";